import { AccordionSummary, AccordionSummaryProps, Stack, Tooltip, Typography } from '@mui/material';
import { MaterialIcon } from '@components';
import { InfoOutlined } from '@mui/icons-material';

interface FormSectionSummaryProps extends AccordionSummaryProps {
  title: string;
  tooltip?: string;
  optional?: boolean;
}

export function FormSectionSummary({ title, tooltip, optional }: FormSectionSummaryProps) {
  return (
    <AccordionSummary expandIcon={<MaterialIcon symbol="expand_more" color="disabled" />}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="subtitle1">{title}</Typography>
        {tooltip && (
          <Tooltip title={title} arrow placement={optional ? 'top' : 'right'}>
            <InfoOutlined color="disabled" fontSize="small" />
          </Tooltip>
        )}
        {optional && (
          <Typography variant="body2" color="text.muted">
            (Optional)
          </Typography>
        )}
      </Stack>
    </AccordionSummary>
  );
}
